import { TabsBase } from "./app.tabs-base.js";

var collection_list_tabs_default = (() => {
    if (customElements.get("collection-list-tabs")) return;
    customElements.define("collection-list-tabs", class CollectionListTabs extends TabsBase {
        onTabActivated(tab) {
            this.updateShopAll(tab, "[data-cl-shop-all]");
        }
    });
})();